export const aciWifi = {
    iconName: 'wifi',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M9.77 17.538a2.462 2.462 0 104.923 0 2.462 2.462 0 00-4.923 0zM16.58 13.187a6.154 6.154 0 00-8.702 0M19.194 10.576a9.847 9.847 0 00-13.925 0M21.463 7.635A13.54 13.54 0 003 7.635',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
